import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { portalAutenticado, usePortalStore } from './portal.store';

/**
 * Exige una sesión **de cliente** para entrar al portal.
 *
 * A diferencia de `RequireAuth` (sesión del panel), aquí la única sesión válida es
 * la del cliente: sus credenciales son su documento y la contraseña del portal, y
 * el token que recibe (`scope: 'cliente'`) no sirve para la API interna.
 */
export function RequirePortal({ children }: { children: ReactNode }) {
  const autenticado = usePortalStore(portalAutenticado);
  const location = useLocation();

  if (!autenticado) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <>{children}</>;
}
